<template>
  <PageContainer v-if="isPropertyLoaded">
    <View gap="sm" direction="column">
      <PropertyDashboardTitle />
      <PropertyDashboardStats :property-id="propertyId" />

      <div ref="showingRequestsSection">
        <PropertyDashboardShowingRequests />
      </div>

      <div ref="escalationsSection">
        <PropertyDashboardEscalations />
      </div>

      <PropertyDashboardUpcomingShowings />
    </View>
  </PageContainer>
</template>

<script setup lang="ts">
import { until } from '@vueuse/core';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { PageContainer, View } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';

import PropertyDashboardEscalations from './property-dashboard-escalations.vue';
import PropertyDashboardShowingRequests from './property-dashboard-showing-requests.vue';
import PropertyDashboardStats from './property-dashboard-stats.vue';
import PropertyDashboardTitle from './property-dashboard-title.vue';
import PropertyDashboardUpcomingShowings from './property-dashboard-upcoming-showings.vue';

const route = useRoute();
const propertyId = computed(() => route.params.propertyId as string);
const propertyStore = usePropertyStore();

const isPropertyLoaded = computed(() => propertyStore.isLoaded);
const escalationsSection = ref<HTMLElement>();
const showingRequestsSection = ref<HTMLElement>();

onMounted(() => {
  scrollToSection();
});

async function scrollToSection() {
  await until(isPropertyLoaded).toMatch((isLoaded) => !!isLoaded);

  const section = getSectionToScroll();

  if (section) {
    setTimeout(() => section.scrollIntoView({ behavior: 'smooth' }), 100);
  }
}

function getSectionToScroll(): HTMLElement | undefined {
  switch (route.hash) {
    case '#escalations-section':
      return escalationsSection.value;

    case '#showing-requests-section':
      return showingRequestsSection.value;
  }
}
</script>
